const app = {
  state: {
    sidebar: {
      opened: true,
      withoutAnimation: false,
    },
    syncInfo: {},
    sc: {},
  },
  mutations: {
    TOGGLE_SIDEBAR: (state) => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
    },
    CHANGE_SIDEBAR: (state, { opened, withoutAnimation }) => {
      state.sidebar.opened = opened;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    SET_SYNC_INFO: (state, data) => {
      state.syncInfo = data;
    },
    sc: (state, { page, param }) => {
      state.sc[page] = param;
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    changeSideBar({ commit }, params) {
      commit("CHANGE_SIDEBAR", params);
    },
    setSyncInfo({ commit }, data) {
      commit("SET_SYNC_INFO", data);
    },
    sc({ commit }, data) {
      commit("sc", data);
    },
  },
};

export default app;
